<script setup lang="ts">
import CvrUpload from "@/types/CvrUpload";
import ConfirmationModal from "@/components/CvrConvert/ConfirmationModal";
import { ref } from 'vue';
import Api from "@/services/api/ApiServiceFabrick";
import i18n from '@/lang/i18n';

const props = defineProps<{
  item: CvrUpload,
  reload: () => void
  showFlash: () => void
}>();

const requesting = ref(false);
const confirmationModalState = ref(false)

const ButtonClass = 'bg-warning';

async function cancel() {
  requesting.value = true;
  const res = await Api().cancelCvrUpload(props.item.parent_id).catch((error) => {
    console.log(error);
  });
  if (res) {
    props.showFlash(
      i18n.global.t('pages.cvr_uploads.cancelMessages.success'),
      "success"
    );
    props.reload()
  }
  confirmationModalState.value = false;
  requesting.value = false;
}

function showConfirmation() {
  confirmationModalState.value = true;
}

function closeConfirmation() {
  confirmationModalState.value = false;
}
</script>

<template>
  <v-btn
    @click="showConfirmation"
    class="bg-warning"
  >
    {{ i18n.global.t('pages.cvr_uploads.list.cancelBtn') }}
  </v-btn>
  <ConfirmationModal
    :modalState="confirmationModalState"
    @confirm="cancel"
    @cancel="closeConfirmation"
    :loading="requesting"
    :title="i18n.global.t('pages.cvr_uploads.cancelMessages.confirmationModalTitle')"
    :note="i18n.global.t('pages.cvr_uploads.cancelMessages.confirmationModalContent')"
    :rightBtnName="i18n.global.t('pages.cvr_uploads.cancelMessages.confirmationModalBtnLabel')"
  />
</template>

<style scoped>
</style>
